module.exports = __webpack_public_path__ + "static/media/img-slide-2@3x.60b47380.png";